import { useEffect, useState } from "react"
import { IAdjudicatorDecisionFilter } from "../../Store/Adjudication/types"
import GridContainer from "./Components/grid/GridContainer"
import { GridButton } from "./Components/grid/GridButton"
import ButtonLightGray from "./Components/ButtonLightGray"
import { BoxButton } from "./Components/BoxButton"
import ChipFactory from "./Components/chips/ChipFactory"
import AdjudicationDecisionSolvedDrawerMoreFilter from "./Components/drawer/AdjudicationDecisionSolvedDrawerMoreFilter"

interface IAdjudicationDecisionSolvedFilterProps {
    onFilterApply: (filter: IAdjudicatorDecisionFilter) => void
    filter: IAdjudicatorDecisionFilter
}

const AdjudicationDecisionSolvedFilter: React.FC<IAdjudicationDecisionSolvedFilterProps> = (props) => {

    const [openMoreFilters, setOpenMoreFilters] = useState<boolean>(false)
    const [adjudicationDecisionFilter, setAdjudicationDecisionFilter] = useState<IAdjudicatorDecisionFilter>(props.filter)

    useEffect(() => {
        setAdjudicationDecisionFilter(props.filter)
    }, [props.filter]);

    const setFilterChip = (filter: IAdjudicatorDecisionFilter) => {
        props.onFilterApply(filter)
        setAdjudicationDecisionFilter(filter)
    }

    const resetFilter = () => {
        setAdjudicationDecisionFilter({})
        props.onFilterApply({})
    }

    const onFilterApply = (filter: IAdjudicatorDecisionFilter) => {
        setAdjudicationDecisionFilter(filter)
        props.onFilterApply(filter);
        setOpenMoreFilters(false)
    }

    return (
        <>
        <GridContainer container style={{paddingTop: 0}}>
            <GridButton item xs={8}>
                <ChipFactory
                    filter={props.filter}
                    setChip={setFilterChip}
                    clearFilter={resetFilter}
                    style={{paddingTop: 0}}
                />
            </GridButton>
            <GridButton item xs={4} style={{ display: "flex", justifyContent: "flex-end" }}>
                <BoxButton>
                    <ButtonLightGray
                        onClick={() => setOpenMoreFilters(true)}
                        variant='text'
                        color="primary"
                        style={{height: "100%"}}
                    >
                        More filters
                    </ButtonLightGray>
                </BoxButton>
            </GridButton>
        </GridContainer>
        <AdjudicationDecisionSolvedDrawerMoreFilter
            anchor='right'
            filter={adjudicationDecisionFilter}
            setFilter={setAdjudicationDecisionFilter}
            open={openMoreFilters}
            onClose={() => setOpenMoreFilters(false)}
            resetFilter={resetFilter}
            onFilterApply={onFilterApply}
        />
        </>
    )
}

export default AdjudicationDecisionSolvedFilter